import { render, staticRenderFns } from "./LeaderForm.vue?vue&type=template&id=aed72738&"
import script from "./LeaderForm.vue?vue&type=script&lang=js&"
export * from "./LeaderForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports